import axios, { _get, _post, _delete, _put, _patch } from "./index";
// 获取所有政策的名称
export const search_all_policy = (data: any) => {
  const req = {
    data,
    url: "zst/user/search/getAllPolicyName",
  };

  return _get(req);
};
export const list_all_policy = (data: any) => {
  const req = {
    data,
    url: "zstapi/data/policy/allData",
  };

  return _get(req);
};
export const set_read = (data: any) => {
  const req = {
    data,
    url: "zst/page/user/work/readNews",
  };

  return _post(req);
};
export const list_information = (data: any) => {
  const req = {
    data,
    url: "zst/page/user/work/getNews",
  };

  return _get(req);
};

export const search_policy_data = (data: any) => {
  const req = {
    data,
    url: "home/getAdminDeclareItemDirectionList",
  };

  return _get(req);
};
export const search_count_data = (data: any) => {
  const req = {
    data,
    url: "zstapi/workbench/getCount",
  };

  return _get(req);
};
export const search_policy_data2 = (data: any) => {
  // const req = {
  //   data,
  //   url: 'zst/user/common/getPolicyNew',
  // };
  const req = {
    data,
    url: "zstapi/user/company/getPolicyNew",
  };

  return _get(req);
};
export const getPolicyNewCount = (data: any) => {
  // const req = {
  //   data,
  //   url: 'zst/user/common/getPolicyNewCount',
  // };
  const req = {
    data,
    url: "zstapi/user/company/getPolicyNewCount",
  };

  return _get(req);
};
export const list_search = (data: any) => {
  const req = {
    data,
    url: "zstapi/data/policy/hot-words",
  };

  return _get(req);
};
export const list_match = (data: any) => {
  const req = {
    data,
    url: "zst/page/user/getPolicy",
  };

  return _get(req);
};
export const list_inform = (data: any) => {
  const req = {
    data,
    url: "home/searchAdminPolicyData",
  };

  return _get(req);
};
// 获取在线兑现列表数据(已经申报的)
export const list_policy_apply = (data: any) => {
  const req = {
    data,
    url: "home/getAdminDeclareItemDirectionList",
  };

  return _get(req);
};
// 获取申报项目内容详情
export const detail_apply = (data: any) => {
  const req = {
    url: `zstapi/data/declare/getAdminDeclareItemDirectionOne/${data}`,
  };

  return _get(req);
};
// 获取所有政策分页
export const list_policy = (data: any) => {
  const req = {
    data,
    url: "home/searchAdminPolicyData",
  };
  return _get(req);
};
// 获取信息类政策单个数据
export const data_policy = (data: any) => {
  const req = {
    url: `zst/user/policy/getByPolicy/${data}`,
  };

  return _get(req);
};

// 首页日历 跳转详情
export const data_policy_calendar = (data: any) => {
  // const req = {
  //   url: `zst/user/policy/getByPolicy/${data}`,
  // };
  const req = {
    url: `zst/zstapi/user/common/getByPolicy/${data}`,
  };
  return _get(req);
};
// 获取匹配详情
export const policy_detail = (data: any) => {
  const req = {
    url: `zst/user/policy/getDeclareIdByPolicy/${data}`,
  };
  return _get(req);
};
// 增加政策浏览量
export const policy_addView = (data: any) => {
  const req = {
    url: `zst/user/policy/addview/${data}`,
  };
  return _patch(req);
};
export const read_addView = (data: any) => {
  const req = {
    url: `zst/user/policyReading/addview/${data}`,
  };
  return _patch(req);
};
// 增加政策浏览量(申报)
export const policy_apply_addView = (data: any) => {
  const req = {
    url: `zst/user/item/addview/${data}`,
  };
  return _patch(req);
};
export const policy_publicy_addView = (data: any) => {
  const req = {
    url: `zst/user/publicity/addview/${data}`,
  };
  return _patch(req);
};
export const data_publicy = (data: any) => {
  const req = {
    url: `home/getAdminPolicyById/${data}`,
  };
  return _get(req);
};

// es查询惠企数据
export const list_publicy = (data: any) => {
  const req = {
    data,
    url: "home/searchAdminPolicyData",
  };

  return _get(req);
};
// 根据id获得政策
export const detail_img = (data: any) => {
  const req = {
    url: `home/getAdminPolicyById/${data}`,
  };
  return _get(req);
};
export const number_subscribe = (data: any) => {
  const req = {
    data,
    url: "zst/page/user/subscribe/getUserSubscribeNumber",
  };
  return _post(req);
};
// 获取申报通知回填
export const data_applied = (data: any) => {
  const req = {
    data,
    url: `zst/page/itemDeclareForm/getItem`,
  };

  return _get(req);
};
// 项目立即兑现
export const apply_project = (data: any) => {
  const req = {
    data,
    url: `zst/page/itemDeclareForm/goToDeclare`,
  };

  return _post(req);
};
export const data_apply = (data: any) => {
  const req = {
    data,
    url: `zst/user/item/getItemDeclareForm`,
  };

  return _post(req);
};
// 删除我的项目
export const delete_project = (data: any) => {
  const req = {
    data,
    url: `zst/page/itemDeclareForm/deleteItem`,
  };

  return _get(req);
};
// 获得公示单条数据
// export const data_publicy = (props: any) => {

//   const req = {
//     url: `user/publicity/getPublicyData/${props}`,
//   };

//   return _get(req);
// };
// 获取公示列表数据(信息公示工作台)
export const list_publicy_center = (data: any) => {
  const req = {
    data,
    url: `zst/page/user/work/getTenPublicity`,
  };

  return _post(req);
};
// 获得我的项目列表数据
export const list_project = (data: any) => {
  const req = {
    // data,
    data,
    url: `zst/page/user/work/getMyItem`,
  };
  return _get(req);
};

// 获取申报通知详情
export const data_inform = (props: any) => {
  const req = {
    url: `zst/user/declareInform/getByDeclareInform/${props}`,
  };

  return _get(req);
};
// 增加申报通知浏览量
export const add_inform_page_view = (props: any) => {
  const req = {
    url: `zst/user/declareInform/addPageView/${props}`,
  };

  return _patch(req);
};
export const list_media = (data: any) => {
  const req = {
    data,
    url: `zst/user/policyReading/getPageReding`,
  };

  return _post(req);
};
// export const detail_img = (data: any) => {
//   const req = {
//     data: { id: data },
//     url: `zst/user/policyReading/getWordReading
// `,
//   };

//   return _get(req);
// };

/* 报告详情 */
export const getPolicyDetail = (data: any) => {
  const req = {
    data,
    url: "zstapi/user/company/getPolicyDetail",
  };

  return _get(req);
};
/* 政策详情 */
export const getPolicyDetailByPolicyId = (data: any) => {
  const req = {
    data,
    url: "zstapi/user/company/getPolicyDetailByPolicyId",
  };
  return _get(req);
};

// 首页申报日历（按年）
export const getDeclareItemPolicyStatisticsByCalendar = (data: any) => {
  const req = {
    data,
    url: `home/getDeclareItemPolicyStatisticsByCalendar`,
  };
  return _get(req);
};
export const getReport = (data: any) => {
  const req = {
    data,
    url: "zstapi/user/company/getReport",
  };

  return _get(req);
};
export const getReportAll = (data: any) => {
  const req = {
    data,
    url: "zstapi/user/company/getReportAll",
  };

  return _get(req);
};
// 查询会员是否收藏
export const isCollection = (props: any) => {
  if (props.declareDirectionId) {
    let req = {
      data: { declareDirectionId: props.declareDirectionId },
      url: `zstapi/member/collection/isCollection/${props.type}/${props.id}`,
    };
    return _get(req);
  } else {
    let req = {
      url: `zstapi/member/collection/isCollection/${props.type}/${props.id}`,
    };
    return _get(req);
  }
};
// 添加会员收藏
export const addCollection = (props: any) => {
  if (props.declareDirectionId) {
    // let req = {
    //   params: { declareDirectionId: props.declareDirectionId },
    //   url: `zstapi/member/collection/add/${props.type}/${props.id}`,
    // };
    // return _postParams(req);
    const req = {
      method: "post",
      params: { declareDirectionId: props.declareDirectionId },
      url: `zstapi/member/collection/add/${props.type}/${props.id}`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    // @ts-ignore
    return axios(req);
  } else {
    let req = {
      url: `zstapi/member/collection/add/${props.type}/${props.id}`,
    };
    return _post(req);
  }
};
// 删除会员收藏
export const deleteCollection = (props: any) => {
  if (props.declareDirectionId) {
    const req = {
      method: "delete",
      params: { declareDirectionId: props.declareDirectionId },
      url: `zstapi/member/collection/delete/${props.type}/${props.id}`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    // @ts-ignore
    return axios(req);
    // let req = {
    //   params: { declareDirectionId: props.declareDirectionId },
    //   url: `zstapi/member/collection/delete/${props.type}/${props.id}`,
    // };
    // return _delete(req);
  } else {
    let req = {
      url: `zstapi/member/collection/delete/${props.type}/${props.id}`,
    };
    return _delete(req);
  }
};
// 查询会员收藏列表
export const collectionList = (data: any, type: any) => {
  const req = {
    data,
    url: `zstapi/member/collection/${type}`,
  };

  return _get(req);
};
export const addAppeal = (data: any) => {
  const req = {
    data,
    url: `zstapi/hd/appeal/add`,
  };

  return _post(req);
};
export const myAppealPageList = (data: any) => {
  const req = {
    data,
    url: `zstapi/hd/appeal/myAppealPageList`,
  };

  return _get(req);
};
// 新增订阅
export const addSubscribe = (data: any) => {
  const req = {
    data,
    url: `zstapi/data/adminSubscribe/add`,
  };

  return _post(req);
};
// 是否可以申报
export const declareIsOk = (data: any) => {
  const req = {
    data,
    url: "zstapi/data/userDeclareItem/isOk",
  };
  return _get(req);
};
// 申报项目再次申报时详情展示
export const declareGetById = (data: any) => {
  const req = {
    data,
    url: "zstapi/data/userDeclareItem/getById",
  };

  return _get(req);
};
// 访问次数
export const getHomePageLog = (data: any) => {
  const req = {
    data,
    url: "zstapi/data/policy/homePageLog",
  };

  return _get(req);
};
